import type { ContactTopic, PlanId } from '@/types'

export const CONTACT_TOPICS: Array<{ value: ContactTopic, label: string }> = [
    { value: 'demo', label: 'A walkthrough' },
    { value: 'pricing', label: 'Pricing' },
    { value: 'other', label: 'Something else' }
]

export const TEAM_SIZES: Array<string> = [
    'Just me',
    '2 to 5 agents',
    '6 to 20 agents',
    'More than 20 agents'
]

export const PLAN_NAMES: Record<PlanId, string> = {
    agent: 'Agent',
    team: 'Team',
    brokerage: 'Brokerage'
}

export const CONTACT_LIMITS = {
    name: 120,
    email: 254,
    company: 160,
    message: 4000
}
